var indentStyle = {"indentZero":"nVsxl","indentOne":"dk8T5","indentTwo":"AUrre","indentThree":"bWC0n","indentFour":"Wv0gq","indentFive":"vlmbh","indentSix":"VAvDu"};

export { indentStyle as i };
//# sourceMappingURL=indentation-d0480e5c.js.map
